import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL + '/api';

const TokenContext = createContext();

export const TokenProvider = ({ children }) => {
  const [tokenSettings, setTokenSettings] = useState({
    token_name: 'Ticket',
    symbol: 'TKT',
    contract_address: '',
    icon_url: '',
    decimals: 9,
    is_active: false,
    min_redeem_amount: 100.0
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchTokenSettings();
  }, []);

  const fetchTokenSettings = async () => {
    try {
      const res = await axios.get(`${API}/token/settings`);
      setTokenSettings(res.data);
    } catch (err) {
      console.error('Failed to fetch token settings:', err);
    } finally {
      setLoading(false);
    }
  };

  // Helper function to display token name/symbol
  const getTokenName = () => tokenSettings.is_active ? tokenSettings.token_name : 'Ticket';
  const getTokenSymbol = () => tokenSettings.is_active ? `$${tokenSettings.symbol}` : '$TKT';
  const getTokenSymbolRaw = () => tokenSettings.is_active ? tokenSettings.symbol : 'TKT'; // Without $ prefix
  const getTokenIcon = () => tokenSettings.icon_url || null;

  return (
    <TokenContext.Provider value={{
      tokenSettings,
      loading,
      getTokenName,
      getTokenSymbol,
      getTokenSymbolRaw,
      getTokenIcon,
      refreshTokenSettings: fetchTokenSettings
    }}>
      {children}
    </TokenContext.Provider>
  );
};

export const useToken = () => {
  const context = useContext(TokenContext);
  if (!context) {
    throw new Error('useToken must be used within a TokenProvider');
  }
  return context;
};
